/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export class PopupHelper {
  /**
   * Returns centered popup options.
   */
  public static getPopupOptions(): string {
    if (typeof window === 'undefined') {
      return '';
    }

    const width = 750;
    const height = 520;

    const winWidth = window?.screen?.width ?? width;
    const winHeight = window?.screen?.height ?? height;

    const left = Math.round(winWidth / 2 - width / 2);
    const top = winHeight > height ? Math.round(winHeight / 2 - height / 2) : 0;

    return `scrollbars=1,resizable=1,toolbar=0,location=0,dialog=1,width=${width},height=${height},left=${left},top=${top}`;
  }

  /**
   * Returns current origin.
   */
  public static getOrigin(): string {
    if (typeof window === 'undefined') return '';

    return (
      window.location.origin ||
      `${window.location.protocol}//${window.location.host}`
    );
  }

  /**
   * Parses URL search params into an object.
   * Safe for SSR (does not rely on window).
   */
  public static parseUrlParams(search: string): Record<string, string> {
    const params = new URLSearchParams(search);
    const data: Record<string, string> = {};

    params.forEach((value, key) => (data[key] = value));
    return data;
  }
}
